import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'smart-agreement-register',
  templateUrl: './agreement-register.component.html',
  styleUrls: ['./agreement-register.component.scss']
})
export class AgreementRegisterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
